import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { Drawer } from '@material-ui/core';
import { useDispatch, useSelector  } from "react-redux";
import imgdashboard from '../Resources/dashboard.jpg';
import { makeStyles } from "@material-ui/core/styles";

import { isEmpty, DicVal} from '../modules/appLibrary';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

/*----------------------------------------------------------------------
 * メインメニュ
 * show: true:open 
 * doClose : close call back
 -----------------------------------------------------------------------*/
export default function Dashboard(props) {

    const [open, setOpen] = useState(false);
    const [windowheight, setwindowheight] = useState(300);

    const useStyles = makeStyles((theme) => ({
        root: {
            "& .MuiFilledInput-root": {
                background: "rgb(256, 256, 256)"
            }
        }
    }));
    const classes = useStyles();


    useEffect(() => {
        setOpen(props.show)
        handleResize();
    }, [props.show])

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    function handleResize() {
        setwindowheight(window.innerHeight);
        let h = window.innerHeight - 100;
    }

    function doClose() {
        props.doClose();
    }

    return (
         <Drawer anchor={"top"} open={open} id="accinfopanel">
            <div style={{ display: 'flex', backgroundColor: '#fff', height:windowheight}}>
                <div style={{ position: 'absolute', top: 0, left: 0 }}>
                <IconButton onClick={doClose} title="閉じる">
                    <Icon style={{ fontSize: 30 }}>close</Icon>
                </IconButton>
                </div>
                <div style={{ position: 'absolute', top: 20, left: 80, color: '#999999', fontSize: 20 }}>KKAP Lite  <span style={{ marginLeft:10 }}>DashBoard</span></div>
                <div style={{ width: '90%', height: '100hv', margin: '0 auto', paddingTop: 60, paddingBottom: 10, backgroundColor: '#fff' }}>
                    <img src={imgdashboard} style={{ maxWidth: '100%', height:'auto' }} alt="" />
                </div>
             </div>
        </Drawer>
    )
}
